import { useEffect, useRef, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useEscape } from '../hooks/useEscape';

interface ModalProps {
  onClose(): void;
  children: ReactNode;
  labelledBy?: string;
}

/** Centered dialog over a dim backdrop (prototype `.modal` / `.dialog`). Esc and backdrop clicks close it. */
export function Modal({ onClose, children, labelledBy }: ModalProps) {
  useEscape(onClose);
  const dialog = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const prev = document.activeElement as HTMLElement | null;
    const first = dialog.current?.querySelector<HTMLElement>('input,select,textarea,button:not([data-close])');
    first?.focus();
    return () => prev?.focus?.();
  }, []);
  return createPortal(
    <div
      className="modal open"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="dialog" role="dialog" aria-modal="true" aria-labelledby={labelledBy} ref={dialog}>
        {children}
      </div>
    </div>,
    document.body,
  );
}
